<template>
  <v-row>
    <v-col
      cols="12"
      lg="12"
    >
      <base-material-card
        id="coloured-line"
        color="bgTemperature"
        icon="mdi-chart-timeline-variant"
        class="px-4 py-3"
      >
        <template v-slot:after-heading>
          <div class="display-2 font-weight-light">
            {{ $t('las24hours') }}
          </div>
        </template>
        <highcharts
          ref="highcharts"
          :options="options"
        />
      </base-material-card>
    </v-col>
  </v-row>
</template>

<script>
  import moment from 'moment'
  import { repositoryFactory } from '@/api/repositoryFactory'

  const temperaturesRespository = repositoryFactory.get('temperatures')

  export default {
    name: 'TemperatureGraphDate',
    props: {
      targetDeviceId: {
        validator: prop => typeof prop === 'string' || prop === null,
        required: true,
      },
    },
    data () {
      return {
        temperatureHistory: {},
        localOptions: {
          title: {
            text: '',
            x: -20, // center
          },
          subtitle: {
            text: '',
            x: -20,
          },
          xAxis: {
            categories: ['00'],
          },
          yAxis: {
            title: {
              text: '',
            },
            plotLines: [{
              value: 0,
              width: 1,
              color: '#808080',
            }],
          },
          tooltip: {
            valueSuffix: '°C',
          },
          legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle',
            borderWidth: 0,
          },
          series: [{ name: '', data: [] }],
        },
      }
    },
    computed: {
      options: {
        get () {
          return this.getOptions()
        },
      },
    },
    watch: {
      targetDeviceId (val) {
        var self = this
        self.fetchData()
      },
    },
    methods: {
      getOptions () {
        this.localOptions.yAxis.title.text = `${this.$t('temperatures')} (°C)`
        return this.localOptions
      },
      fetchData (targetDeviceId) {
        var self = this
        temperaturesRespository.getByDate(self.targetDeviceId).then(response => {
          self.temperatureHistory = response.data.data
          if (response.data.isValid) {
            if (response.data.data.length === 0) {
              self.options.xAxis.categories = ['00']
              self.options.series = [{ name: '', data: [] }]
            } else {
              self.options.xAxis.categories = self.temperatureHistory.map(l => moment(String(l.registerAt)).format('HH') + 'h')
              self.options.series = [{
                                       color: '#FF0000',
                                       name: 'Max',
                                       data: self.temperatureHistory.map(l => l.maxCelsius),
                                     },
                                     {
                                       color: '#0D47A1',
                                       name: 'Min',
                                       data: self.temperatureHistory.map(l => l.minCelsius),
                                     },
                                     {
                                       color: '#FFFF00',
                                       name: 'Avg',
                                       data: self.temperatureHistory.map(l => l.avgCelsius),
                                     },
              ]
            }
          } else {
            self.options.xAxis.categories = ['00']
            self.options.series = [{ name: '', data: [] }]
          }
        }).catch(err => {
          self.showErrorMessage = true
          self.errorMessage = err
        })
      },
    },
  }
</script>
<style>
.bgTemperature{
  background-color: #023A66 !important;
}
</style>
<style lang="sass">
  #coloured-line
    .ct-series-a .ct-line,
    .ct-series-a .ct-point
      stroke: #00cae3 !important

  #multiple-bar
    .ct-series-a .ct-bar
      stroke: #00cae3 !important

    .ct-series-b .ct-bar
      stroke: #f44336 !important

  #pie
    .ct-series-a .ct-slice-pie
      fill: #00cae3 !important

    .ct-series-b .ct-slice-pie
      fill: #f44336 !important
</style>
